import { createFileRoute } from "@tanstack/react-router";

import { ControlCenter } from "@/pages/admin/ControlCenter";

export const Route = createFileRoute("/admin/control")({
  component: ControlCenter,
});
